module.exports = __webpack_public_path__ + "img/Income Protection_Selected.8752327a.svg";